

/**
 * @param upsells [{id, quantity}] - upsells-parameter is an array of {id, quantityString}-Objects
 */
if(typeof addVariantToCart != 'function') {
    function addVariantToCart(id,quantityString,sellingPlanString, upsells) {
        //event.preventDefault();
        //console.log("addVariantToCart: ",id);
        console.log('----- addVariantToCart -----')
        console.log('id: ' + id)
        console.log('quantityString: ' + quantityString)
        console.log('sellingPlanString: ' + sellingPlanString)
        console.log('upsells: ' + upsells)
        console.trace('Aufrufstelle')

        let quantitySelector = 1;
        if(!!quantityString) {
            var quantitySelectorElem = document.querySelector('#'+quantityString+' .rocker_input input');
            if(quantitySelectorElem != null){
                quantitySelector = quantitySelectorElem.value;
            }
        }
        let atcJSON = null;
        if(!!sellingPlanString){
          console.log('!!sellingPlanString')
            const singleProductForm = document.querySelector('form.singleProductForm')
            if(singleProductForm && singleProductForm.querySelector('.gPreorderProperty')){
               atcJSON = {"items": [{
                 "id": id,
                 "quantity": quantitySelector, 
                 "selling_plan": Number(sellingPlanString),
                 "properties": {
                      "_is_preorder": singleProductForm.querySelector('.gPreorderProperty').value,
                      "_preorder_locale": singleProductForm.querySelector('.gPreorderLocale').value
                 }
               }]};
            }else{
              atcJSON = {"items": [{"id": id,"quantity": quantitySelector, "selling_plan": Number(sellingPlanString)}]};
            }
        }
        else{
          console.log('else !!sellingPlanString')
          const singleProductForm = document.querySelector('form.singleProductForm')
            if(singleProductForm && singleProductForm.querySelector('.gPreorderProperty')){
               atcJSON = {"items": [{
                 "id": id,
                 "quantity": quantitySelector,
                 "properties": {
                      "_is_preorder": singleProductForm.querySelector('.gPreorderProperty').value,
                      "_preorder_locale": singleProductForm.querySelector('.gPreorderLocale').value
                 }
               
               }] };
            }else{
                atcJSON = {
                  "items": [
                    {"id": id,"quantity": quantitySelector},
                  ]
                }
                // add upsell items to atcJSON.items array
                if (upsells && upsells.length > 0) {
                  upsells.forEach(upsellItem => {
                    atcJSON.items.push(upsellItem)
                  });
                }
            }
        }
        console.log(sellingPlanString);
        console.log(atcJSON);
        Shopify.theme.cart.addToCart(atcJSON);
        console.log('----- addVariantToCart end -----')
        window.productAddOns = []   // reset temporary safed upsell/addon products
    }
}
